import { Analytics } from './analytics'

export enum MindsetAnalyticsEvent {
   mindsetOpenViaUtilityPanel = 'Mindset clicked via the utility panel',
}

export default class MindsetAnalytics implements Analytics {
   static mindsetOpenViaUtilityPanel = (processName: string) => {
      return Analytics.emitEvent(MindsetAnalyticsEvent.mindsetOpenViaUtilityPanel, {
         "Process name": processName
      })
   }
}